export default {
    marketingWebsiteUrl: 'https://get-e.com',
    privacyPolicyUrl: 'https://get-e.com/privacy',
    termsAndConditionsUrl: 'https://get-e.com/terms-and-conditions',
    copyrightStartYear: 2015,
};
